const DateNoTz = require('./DateNoTz');

class WorkOrderRecord {

  constructor(constructorObject, displayNames) {
    for(var key in constructorObject){
        this[key] = constructorObject[key];
    }
    this.displayNames = displayNames;

    // Assign an End Date if weekly
    if(this.displayDate && displayNames && displayNames.date_selection && displayNames.date_selection.indexOf('week') > -1){
      var requestedStartDate = new DateNoTz(this.woRequestedDateTime)

      requestedStartDate.shiftToNextInstanceOfDay(displayNames.weekly_start_day || 0, false)

      this.requestedStartDate = requestedStartDate
    }

    this.ServiceName = this.getDisplayServiceName();
    if(this.WOComments) {
      this.UserComment = this.getQueuedComment(this.WOComments);
    }
    if(this.WOWasteType) {
      this.WasteStreamName = this.orders
        .map(x => this.getDisplayWasteStreamName(x.WOWasteType))
        .filter(x => x && x != '')
    }
  }
  getDisplayServiceName() {
    if(this.displayNames && this.displayNames.service_name){
      return this.displayNames.service_name
    }
    else{
      return this.woServiceType
    }
  }
  getDisplayWasteStreamName(apiValue){
    var displayName

    if(this.displayNames && this.displayNames.wasteStreams){
      
      apiValue = apiValue.toLowerCase()

      // Check Waste Streams
      var displayName = this.displayNames.wasteStreams.find(wasteStream => {
          return wasteStream.api_value.toLowerCase() == apiValue
      })

      if(displayName){

        // Check if the Waste Stream is to be hidden
        if(displayName.is_hidden){
          displayName = 'hidestream'
        }
        else{
          displayName = displayName.waste_stream_name
        }

      }
      else{
        // Check Waste Stream Combos
        displayName = this.displayNames.wasteStreamCombos.find(wasteStreamCombo => {
          return wasteStreamCombo.api_value.toLowerCase() == apiValue
        })
        displayName = displayName ? displayName.primary_waste_stream_name : null
      }
      
    }

    return displayName || apiValue
  }
  getQueuedComment(text) {
    if(text == '') return '';
    text = text.split('Selected Option')[0] || text;
    text = text.split('Paid Collection')[0] || text;
    text = text.split(parseInt(this.woAmountPaid || this.WOAmountPaid) + ' Bpoint receipt')[0] || text;
    text = text.split('Name: ' + this.Comments);
    return (text[1] || '').trim();
  }
}

module.exports = WorkOrderRecord